import React from "react";

const DownloadList = () => {
  const files = [
    "13.dwg",
    "ABHISHEK B U PROJECTION OF POINTS.dwg",
    "EX NO 12.dwg",
    "MKC_AUTOCAD.zip",
    "auto15.zip",
    "rpg_9.dwg",
    "rpx_10.dwg",
    "rpx_9.dwg",
    "Problem 11.dwg", 
    "BADASS1.dwg",
    "BADASS2.dwg"
  ];

  return (
    <div style={styles.container}>
      <style>{`
        .file-list {
          list-style: none;
          padding: 0;
        }

        .file-item {
          margin: 10px 0;
          background: #2c2c2c;
          padding: 10px;
          border-radius: 8px;
          transition: background 0.3s;
        }

        .file-item a {
          color: #90caf9;
          text-decoration: none;
          font-size: 16px;
        }

        .file-item:hover {
          background: #424242;
        }
      `}</style>

      <h2 style={{ color: "#00e676" }}>YOYO RP</h2>
      <ul className="file-list">
        {files.map((file, index) => (
          <li key={index} className="file-item">
            <a href={`/${encodeURIComponent(file)}`} download>
              {file}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    backgroundColor: "#1e1e1e",
    color: "white",
    minHeight: "100vh",
    fontFamily: "Arial, sans-serif"
  }
};

export default DownloadList;
